import { isUndefined } from 'lodash';
import { View as RNView } from 'react-native';
import { View } from '@shared/components/View';
import { MBCircularProgressBar } from '@shared/components/loading';
import { MBVideo } from '@shared/components/video';
import { MBChatAttachmentProps } from '../index';

/*
    Video attachment for chat thread.
    TOOD(fant): semitransparent when uploading

    Play video inline on mobile web instead of going fullscreen:
    https://stackoverflow.com/a/39051722/9117995
*/
export function MBChatVideoAttachment({
  attachment,
  progress,
  style,
  isSending,
}: MBChatAttachmentProps) {
  return (
    <RNView style={[style, { width: '100%', height: '100%' }]}>
      <MBVideo muted fill autoPlay={false} source={{ uri: attachment.url }} />
      {isSending && !isUndefined(progress) && (
        <View absolute center>
          <MBCircularProgressBar progress={progress} />
        </View>
      )}
    </RNView>
  );
}
